// src/components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const AdminProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");

  if (!token) {
    // Redirect to login if no token found
    return <Navigate to="/Admin" replace />;
  }

  return children;
};

export default AdminProtectedRoute;
